/* processor/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

export const KeyCodec = t.intersection([
  t.type({}),
  t.partial({
    Name: t.string,
    Value: t.string,
  }),
]);

export const FloorLimitCodec = t.intersection([
  t.type({}),
  t.partial({
    Name: t.string,
    Value: t.number,
  }),
]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

export const BinCodec = t.intersection([
  t.type({
    Account: t.array(t.string),
    From: t.string,
    To: t.string,
    Length: t.number,
  }),
  t.partial({
    AmountFrom: t.number,
    AmountTo: t.number,
  }),
]);
export const CardTypeCodec = t.intersection([
  t.type({
  }),
  t.partial({
    ProductID: t.string,
    ProductName: t.string,
    AmountFrom: t.number,
    AmountTo: t.number,
  }),
]);

export type Bin = t.TypeOf<typeof BinCodec>;
export type CardType = t.TypeOf<typeof CardTypeCodec>;

const AdditionalDataCodec = t.type({
  Tag: tOptional(t.string),
  Value: tOptional(t.string),
  Encrypted: t.boolean,
});

export type AdditionalData = t.TypeOf<typeof AdditionalDataCodec>;

const AttributeCodec = t.intersection([
  t.type({
    Name: t.string,
  }),
  t.partial({
    Port: t.number,
    FIIC: tOptional(t.string),
    Bin: t.array(BinCodec),
    CardType: t.array(CardTypeCodec),
    Host: t.string,
    AdditionalData: t.array(AdditionalDataCodec),
    MaintainTransactionSequence: t.boolean,
  }),
]);

const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const ProcessorCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "ProcessorCodec"
);

export type Processor = t.TypeOf<typeof ProcessorCodec>;

export enum ProcessorActionTypes {
  FETCH = "@@processor/FETCH",
  FETCH_SUCCESS = "@@processor/FETCH_SUCCESS",
  FETCH_ERROR = "@@processor/FETCH_ERROR",
  SAVE_REQUEST = "@@processor/SAVE_REQUEST",
  SAVE_SUCCESS = "@@processor/SAVE_SUCCESS",
  SAVE_ERROR = "@@processor/SAVE_ERROR",
  DELETE_REQUEST = "@@processor/DELETE_REQUEST",
  DELETE_SUCCESS = "@@processor/DELETE_SUCCESS",
  DELETE_ERROR = "@@processor/DELETE_ERROR",
}

export interface ProcessorState {
  readonly loading: boolean;
  readonly data: Processor | undefined;
  readonly errors?: string;
}
